import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

interface DescriptionSkeletonProps {
  isMobile: boolean;
  sectionStyle: any;
}

export function DescriptionSkeleton({ isMobile, sectionStyle }: DescriptionSkeletonProps) {
  return (
    <Box className="description" style={sectionStyle} width={'100%'}>
      <Box className="description-main">
        <Skeleton variant="circular" width={isMobile ? 32 : 58} height={isMobile ? 32 : 58} />
        <Skeleton
          variant="text"
          width={100}
          height={18}
          sx={{ marginTop: isMobile ? '24px' : '42px' }}
        />
        <Skeleton variant="text" width={130} height={38} sx={{ marginTop: '4px' }} />

        {!isMobile && (
          <div className="description-products-skelton" style={{ marginTop: '16px' }}>
            <Skeleton variant="rounded" width={60} height={64} />
            <div className="text-wrapper">
              <Skeleton variant="rectangular" width={120} height={20} />
              <Skeleton variant="rectangular" width={60} height={20} />
            </div>
          </div>
        )}

        <Stack direction={'row'} justifyContent={'space-between'} marginTop={'12px'}>
          <Skeleton variant="text" width={60} height={14} />
          <div
            style={{
              height: '14px',
            }}
          >
            <Skeleton variant="text" width={60} height={14} />
          </div>
        </Stack>

        <Stack direction={'row'} justifyContent={'space-between'} marginTop={'12px'}>
          <Skeleton variant="text" width={30} height={14} />
          <Skeleton variant="text" width={60} height={14} />
        </Stack>

        <Stack direction={'row'} justifyContent={'space-between'} marginTop={'12px'}>
          <Skeleton variant="text" width={60} height={19} />
          <Skeleton variant="text" width={60} height={19} />
        </Stack>
      </Box>
    </Box>
  );
}
